(function () {
  "use strict";

  if (window.__ssProductPromotionActivityLoaded) return;
  window.__ssProductPromotionActivityLoaded = true;

  var MOUNT_SELECTOR = "[data-ss-product-promotion-mount]";
  var WEEK_MS = 7 * 24 * 60 * 60 * 1000;
  var NO_BENEFIT_TYPE = "NO_BENEFIT";
  var STRONG_BENEFITS = ["FREE_GIFT", "BUY_N_PAY_M", "BUY_X_GET_Y"];
  var CARD_STYLES = ["hero", "compact"];
  var COLOR_VARIANTS = ["theme", "sale", "navy", "green"];

  function init(scope) {
    Array.from((scope || document).querySelectorAll(MOUNT_SELECTOR)).forEach(
      hydrateMount,
    );
  }

  async function hydrateMount(mount) {
    if (!mount || mount.__ssProductPromotionLoading) return;
    mount.__ssProductPromotionLoading = true;
    mount.__ssProductPromotionVariants = readVariants(mount);

    try {
      var data = await fetchJson(productBootstrapUrl(mount));
      var campaign = chooseCampaign(data.activeCampaigns || [], mount);
      if (!campaign) {
        hideMount(mount);
        return;
      }
      mount.__ssProductPromotionPayload = data;
      mount.__ssProductPromotionCampaign = campaign;
      renderMount(mount);
      bindVariantUpdates(mount);
    } catch (error) {
      hideMount(mount);
    } finally {
      mount.__ssProductPromotionLoading = false;
    }
  }

  async function fetchJson(url) {
    var lastError;
    for (var attempt = 0; attempt < 2; attempt += 1) {
      var response;
      try {
        response = await fetch(url, { credentials: "same-origin" });
      } catch (error) {
        lastError = error;
        if (attempt === 1) throw error;
        continue;
      }
      if (!response.ok) {
        var requestError = new Error("Request failed: " + response.status);
        if (response.status < 500 || attempt === 1) throw requestError;
        lastError = requestError;
        continue;
      }
      try {
        return await response.json();
      } catch (error) {
        lastError = error;
        if (attempt === 1) throw error;
      }
    }
    throw lastError;
  }

  function productBootstrapUrl(mount) {
    var url = new URL(mount.dataset.proxyPath, window.location.origin);
    if (mount.dataset.productHandle) {
      url.searchParams.set("productHandle", mount.dataset.productHandle);
    }
    if (mount.dataset.collectionHandles) {
      url.searchParams.set(
        "collectionHandles",
        mount.dataset.collectionHandles,
      );
    }
    return url.toString();
  }

  function chooseCampaign(campaigns, mount) {
    var productHandle = normalizeHandle(mount.dataset.productHandle);
    var collectionHandles = normalizeHandleList(
      mount.dataset.collectionHandles,
    );
    return campaigns
      .filter(function (campaign) {
        return (
          productPromotionConfig(campaign) &&
          campaignMatchesMount(campaign, productHandle, collectionHandles)
        );
      })
      .sort(function (left, right) {
        return (
          scopeRank(left, productHandle) - scopeRank(right, productHandle) ||
          benefitRank(left) - benefitRank(right) ||
          dateMs(right.startsAt) - dateMs(left.startsAt)
        );
      })[0];
  }

  function campaignMatchesMount(campaign, productHandle, collectionHandles) {
    if (!campaign || isGlobalCampaign(campaign)) return false;
    var targets = campaignTargets(campaign);
    if (
      productHandle &&
      targets.excludedProductHandles.includes(productHandle)
    ) {
      return false;
    }
    if (hasIntersection(collectionHandles, targets.excludedCollectionHandles)) {
      return false;
    }
    if (targets.eligibleProductHandles.length) {
      return (
        Boolean(productHandle) &&
        targets.eligibleProductHandles.includes(productHandle)
      );
    }
    return hasIntersection(
      collectionHandles,
      targets.eligibleCollectionHandles,
    );
  }

  function campaignTargets(campaign) {
    var targetingConfig = campaign.targetingConfig || {};
    return {
      eligibleProductHandles: normalizeHandleList(
        campaign.eligibleProductHandles || targetingConfig.productHandles,
      ),
      eligibleCollectionHandles: normalizeHandleList(
        campaign.eligibleCollectionHandles || targetingConfig.collectionHandles,
      ),
      excludedProductHandles: normalizeHandleList(
        campaign.excludedProductHandles ||
          targetingConfig.excludedProductHandles,
      ),
      excludedCollectionHandles: normalizeHandleList(
        campaign.excludedCollectionHandles ||
          targetingConfig.excludedCollectionHandles,
      ),
    };
  }

  function isGlobalCampaign(campaign) {
    var mode = String(
      (campaign.targetingConfig && campaign.targetingConfig.mode) ||
        campaign.targetMode ||
        "",
    ).toUpperCase();
    return mode === "ALL";
  }

  function scopeRank(campaign, productHandle) {
    var targets = campaignTargets(campaign);
    return productHandle &&
      targets.eligibleProductHandles.includes(productHandle)
      ? 0
      : 1;
  }

  function benefitRank(campaign) {
    return STRONG_BENEFITS.includes(campaignBenefitType(campaign)) ? 0 : 1;
  }

  function renderMount(mount) {
    var campaign = mount.__ssProductPromotionCampaign;
    if (!campaign) {
      hideMount(mount);
      return;
    }
    var isShowcase = campaignBenefitType(campaign) === NO_BENEFIT_TYPE;
    var tiers = sortTiers(campaign);
    var tier = tiers[0];
    if (!isShowcase && !tier) {
      hideMount(mount);
      return;
    }

    var payload = mount.__ssProductPromotionPayload || {};
    var config = productPromotionConfig(campaign);
    if (!config) {
      hideMount(mount);
      return;
    }
    var style = readCardStyle(config);
    var colorVariant = readColorVariant(config);
    if (isShowcase) {
      applyPresentationClasses(mount, style, colorVariant);
      mount.hidden = false;
      mount.innerHTML = showcaseCardHtml(
        campaign,
        config,
        countdownHtml(campaign, payload.serverNow, mount),
        mount,
      );
      bindDescriptionOpen(mount);
      return;
    }
    var title = campaignDisplayTitle(campaign, tier, mount);
    var titleHelp = descriptionHelpButtonHtml(campaign, mount);
    var benefit = isRepeatablePackCampaign(campaign)
      ? tiers
          .map(function (configuredTier) {
            return (
              '<div class="ss-product-promotion-card__tier">' +
              productBenefitLineHtml(campaign, configuredTier, mount) +
              "</div>"
            );
          })
          .join("")
      : productBenefitLineHtml(campaign, tier, mount);
    var countdown = countdownHtml(campaign, payload.serverNow, mount);
    var footer = footerHtml(config, campaign, mount);

    applyPresentationClasses(mount, style, colorVariant);
    mount.hidden = false;
    mount.innerHTML =
      style === "compact"
        ? compactCardHtml(title, titleHelp, benefit, countdown, footer)
        : heroCardHtml(title, titleHelp, benefit, countdown, footer);
    bindDescriptionOpen(mount);
  }

  function showcaseCardHtml(campaign, config, countdown, mount) {
    var title = String((campaign && campaign.name) || "").trim();
    var titleHelp = descriptionHelpButtonHtml(campaign, mount);
    var price = showcasePriceHtml(mount);
    var footer = footerHtml(config, campaign, mount);
    var options = { showcase: true };
    return readCardStyle(config) === "compact"
      ? compactCardHtml(title, titleHelp, price, countdown, footer, options)
      : heroCardHtml(title, titleHelp, price, countdown, footer, options);
  }

  function showcasePriceHtml(mount) {
    var price = currentVariantPriceCents(mount);
    if (price <= 0) return "";
    var compareAtPrice = currentVariantCompareAtPriceCents(mount);
    var isSale = compareAtPrice > price;
    var discountPercentage = isSale
      ? Math.round(((compareAtPrice - price) / compareAtPrice) * 100)
      : 0;
    return (
      '<div class="ss-product-promotion-showcase__price-row">' +
      '<span class="ss-product-promotion-showcase__sale-price">' +
      escapeHtml(formatMoney(price, mount)) +
      "</span>" +
      (isSale
        ? '<s class="ss-product-promotion-showcase__compare-price">' +
          escapeHtml(formatMoney(compareAtPrice, mount)) +
          "</s>" +
          '<span class="ss-product-promotion-showcase__discount">-' +
          discountPercentage +
          "%</span>"
        : "") +
      "</div>"
    );
  }

  function heroCardHtml(title, titleHelp, benefit, countdown, footer, options) {
    var isShowcase = Boolean(options && options.showcase);
    var cardClassName =
      "ss-product-promotion-card ss-product-promotion-card--hero" +
      (isShowcase ? " ss-product-promotion-card--showcase" : "");
    var offerClassName =
      "ss-product-promotion-card__offer" +
      (isShowcase ? " ss-product-promotion-card__offer--showcase" : "");
    return (
      '<div class="' +
      cardClassName +
      '">' +
      '<div class="ss-product-promotion-card__header">' +
      '<div class="ss-product-promotion-card__title-wrap">' +
      '<h3 class="ss-product-promotion-card__title">' +
      escapeHtml(title) +
      "</h3>" +
      titleHelp +
      "</div>" +
      countdown +
      "</div>" +
      '<div class="' +
      offerClassName +
      '">' +
      (isShowcase ? "" : tagIconHtml()) +
      '<div class="ss-product-promotion-card__offer-copy">' +
      '<div class="ss-product-promotion-card__rule">' +
      benefit +
      "</div>" +
      "</div>" +
      "</div>" +
      footer +
      "</div>"
    );
  }

  function compactCardHtml(
    title,
    titleHelp,
    benefit,
    countdown,
    footer,
    options,
  ) {
    var isShowcase = Boolean(options && options.showcase);
    var className =
      "ss-product-promotion-card ss-product-promotion-card--compact" +
      (isShowcase ? " ss-product-promotion-card--showcase" : "") +
      (countdown ? " ss-product-promotion-card--has-countdown" : "");
    var benefitRowClassName =
      "ss-product-promotion-card__benefit-row" +
      (isShowcase ? " ss-product-promotion-card__benefit-row--showcase" : "");
    return (
      '<div class="' +
      className +
      '">' +
      '<div class="ss-product-promotion-card__topline">' +
      '<div class="ss-product-promotion-card__title-wrap">' +
      '<div class="ss-product-promotion-card__eyebrow">' +
      escapeHtml(title) +
      "</div>" +
      titleHelp +
      "</div>" +
      (countdown
        ? '<div class="ss-product-promotion-card__aside">' +
          countdown +
          "</div>"
        : "") +
      "</div>" +
      '<div class="' +
      benefitRowClassName +
      '">' +
      (isShowcase ? "" : tagIconHtml()) +
      '<div class="ss-product-promotion-card__rule">' +
      benefit +
      "</div>" +
      "</div>" +
      footer +
      "</div>"
    );
  }

  function footerHtml(config, campaign, mount) {
    var text = String((config && config.summary) || "").trim();
    var link = relatedProductsLinkHtml(campaign, mount);
    if (!text && !link) return "";
    return (
      '<div class="ss-product-promotion-card__footer">' +
      (text
        ? '<span class="ss-product-promotion-card__footer-text">' +
          escapeHtml(text) +
          "</span>"
        : "") +
      link +
      "</div>"
    );
  }

  function relatedProductsLinkHtml(campaign, mount) {
    var href = relatedProductsUrl(campaign);
    if (!href) return "";
    var label = String(mount.dataset.relatedProductsLabel || "").trim();
    if (!label) return "";
    return (
      '<a class="ss-product-promotion-card__link" href="' +
      escapeAttribute(href) +
      '">' +
      escapeHtml(label) +
      "</a>"
    );
  }

  function relatedProductsUrl(campaign) {
    var badge = campaignBadge(campaign);
    var directLink = String(
      badge.link || (campaign && campaign.badgeLink) || "",
    ).trim();
    if (directLink) return directLink;
    var badgeFilterValue = String(
      badge.filterValue || (campaign && campaign.badgeFilterValue) || "",
    ).trim();
    if (!badgeFilterValue) return "";
    return (
      "/collections/all?filter.p.m.custom.product_badges=" +
      encodeURIComponent(badgeFilterValue)
    );
  }

  function campaignBadge(campaign) {
    return campaign && campaign.badge && typeof campaign.badge === "object"
      ? campaign.badge
      : {};
  }

  function descriptionHelpButtonHtml(campaign, mount) {
    if (!campaignDescriptionHtml(campaign)) return "";
    var detailsLabel = String(
      (mount && mount.dataset.promoDetails) || "Promotion details",
    ).trim();
    return (
      '<button type="button" class="ss-product-promotion-card__help" data-ss-product-promotion-description aria-label="' +
      escapeAttribute(detailsLabel) +
      '">' +
      '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="12" cy="12" r="10"></circle><path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3"></path><path d="M12 17h.01"></path></svg>' +
      "</button>"
    );
  }

  function campaignDescriptionHtml(campaign) {
    return String(
      (campaign &&
        (campaign.descriptionHtml ||
          campaign.description_html ||
          campaign.description)) ||
        "",
    ).trim();
  }

  function bindDescriptionOpen(mount) {
    if (mount.__ssProductPromotionDescriptionBound) return;
    mount.__ssProductPromotionDescriptionBound = true;
    mount.addEventListener("click", function (event) {
      var target =
        event.target instanceof Element
          ? event.target.closest("[data-ss-product-promotion-description]")
          : null;
      if (!target) return;
      event.preventDefault();
      document.dispatchEvent(
        new CustomEvent("ss:promotion:description:open", {
          detail: { campaign: mount.__ssProductPromotionCampaign },
        }),
      );
    });
  }

  function campaignDisplayTitle(campaign, tier, mount) {
    return (
      String((campaign && campaign.name) || "").trim() ||
      campaignRuleTitle(campaign, tier, mount)
    );
  }

  function campaignRuleTitle(campaign, tier, mount) {
    var benefitType = campaignBenefitType(campaign);
    var threshold = tierThreshold(tier);
    var thresholdText =
      campaignThresholdType(campaign) === "QUANTITY"
        ? promotionQuantityText(campaign, threshold, mount)
        : formatMoney(centsFromAmount(threshold), mount);

    if (benefitType === "BUY_N_PAY_M") {
      var payQuantity = Number(tier.payQuantity || 0);
      var freeQuantity = Math.max(0, threshold - payQuantity);
      if (freeQuantity > 0) {
        return (
          renderPromoText(mount, "TitleBuyGetFree", {
            count: promotionQuantityText(campaign, threshold, mount),
            free: promotionQuantityText(campaign, freeQuantity, mount),
          }) || campaignFallbackTitle(campaign, mount)
        );
      }
      return (
        renderPromoText(mount, "TitleBuyPay", {
          count: promotionQuantityText(campaign, threshold, mount),
          pay: promotionQuantityText(campaign, payQuantity, mount),
        }) || campaignFallbackTitle(campaign, mount)
      );
    }

    if (benefitType === "BUY_X_GET_Y") {
      var buyXGetYPercentage = promotionPercentageOff(tier);
      return (
        renderPromoText(mount, "TitleBuyLowestDiscount", {
          count: promotionQuantityText(campaign, threshold, mount),
          discounted: promotionQuantityText(
            campaign,
            Number(tier.discountedQuantity || 0),
            mount,
          ),
          discount: trimDisplayNumber(buyXGetYPercentage) + "%",
        }) || campaignFallbackTitle(campaign, mount)
      );
    }

    if (benefitType === "FIXED_BUNDLE_PRICE") {
      return (
        renderPromoText(mount, "TitleBuyFor", {
          count: thresholdText,
          amount: formatMoney(
            centsFromAmount(tier.fixedBundlePrice || 0),
            mount,
          ),
        }) || campaignFallbackTitle(campaign, mount)
      );
    }

    if (benefitType === "PERCENTAGE_OFF") {
      var percentageValue = trimDisplayNumber(tier.percentage || 0) + "%";
      return campaignThresholdType(campaign) === "QUANTITY"
        ? renderPromoText(mount, "TitleBuySave", {
            count: thresholdText,
            value: percentageValue,
          }) || campaignFallbackTitle(campaign, mount)
        : renderPromoText(mount, "TitleSpendPercentage", {
            amount: compactThresholdMoney(centsFromAmount(threshold), mount),
            value: percentageValue,
          }) || campaignFallbackTitle(campaign, mount);
    }

    if (benefitType === "FIXED_AMOUNT_OFF") {
      var discountValue = formatMoney(
        centsFromAmount(tier.discountAmount || 0),
        mount,
      );
      return campaignThresholdType(campaign) === "QUANTITY"
        ? renderPromoText(mount, "TitleBuySave", {
            count: thresholdText,
            value: discountValue,
          }) || campaignFallbackTitle(campaign, mount)
        : renderPromoText(mount, "TitleSpendSave", {
            amount: thresholdText,
            value: discountValue,
          }) || campaignFallbackTitle(campaign, mount);
    }

    if (benefitType === "FREE_GIFT") {
      return (
        renderPromoText(mount, "TitleFree", {
          gift: giftTitle(tier, mount),
        }) || campaignFallbackTitle(campaign, mount)
      );
    }

    return campaignFallbackTitle(campaign, mount);
  }

  function campaignFallbackTitle(campaign, mount) {
    return String(
      (campaign && campaign.name) || promoTemplate(mount, "TitleFallback"),
    ).trim();
  }

  function productBenefitLineHtml(campaign, tier, mount) {
    if (campaignBenefitType(campaign) === "FREE_GIFT") {
      return promotionDynamicValueHtml(productOfferLine(campaign, tier, mount));
    }
    if (campaignBenefitType(campaign) === "BUY_X_GET_Y") {
      return promotionDynamicValueHtml(campaignRuleTitle(campaign, tier, mount));
    }

    var threshold = tierThreshold(tier);
    var savingsCents = estimatedSavingsCents(campaign, tier, mount);
    var eachCents =
      campaignThresholdType(campaign) === "QUANTITY"
        ? estimatedEachPriceCents(campaign, tier, mount)
        : 0;
    var thresholdHtml =
      campaignThresholdType(campaign) === "QUANTITY"
        ? promotionQuantityHtml(campaign, threshold, mount)
        : promotionAmountHtml(trimDisplayNumber(threshold));

    if (campaignBenefitType(campaign) === "FIXED_BUNDLE_PRICE") {
      var bundleAmountHtml = promotionAmountHtml(
        formatMoney(centsFromAmount(tier.fixedBundlePrice || 0), mount),
      );
      if (savingsCents > 0) {
        return (
          renderPromoHtml(mount, "BenefitBundlePriceSave", {
            count: thresholdHtml,
            amount: bundleAmountHtml,
            savings: promotionAmountHtml(formatMoney(savingsCents, mount)),
          }) ||
          renderPromoHtml(mount, "BenefitBundlePrice", {
            count: thresholdHtml,
            amount: bundleAmountHtml,
          }) ||
          promotionDynamicValueHtml(campaignRuleTitle(campaign, tier, mount))
        );
      }
      return (
        renderPromoHtml(mount, "BenefitBundlePrice", {
          count: thresholdHtml,
          amount: bundleAmountHtml,
        }) ||
        promotionDynamicValueHtml(campaignRuleTitle(campaign, tier, mount))
      );
    }

    if (eachCents && savingsCents > 0) {
      return (
        renderPromoHtml(mount, "BenefitEachSave", {
          each: promotionAmountHtml(formatMoney(eachCents, mount)),
          savings: promotionAmountHtml(formatMoney(savingsCents, mount)),
          count: thresholdHtml,
        }) ||
        promotionDynamicValueHtml(campaignRuleTitle(campaign, tier, mount))
      );
    }

    if (eachCents) {
      return (
        renderPromoHtml(mount, "BenefitEach", {
          each: promotionAmountHtml(formatMoney(eachCents, mount)),
          count: thresholdHtml,
        }) ||
        promotionDynamicValueHtml(campaignRuleTitle(campaign, tier, mount))
      );
    }

    if (savingsCents > 0) {
      var savingsHtml =
        campaignThresholdType(campaign) === "QUANTITY"
          ? renderPromoHtml(mount, "BenefitSaveBuy", {
              savings: promotionAmountHtml(formatMoney(savingsCents, mount)),
              count: thresholdHtml,
            })
          : renderPromoHtml(mount, "BenefitSaveSpend", {
              savings: promotionAmountHtml(formatMoney(savingsCents, mount)),
              amount: promotionAmountHtml(
                formatMoney(centsFromAmount(threshold), mount),
              ),
            });
      if (savingsHtml) return savingsHtml;
    }

    return promotionDynamicValueHtml(
      productOfferLine(campaign, tier, mount) ||
        campaignRuleTitle(campaign, tier, mount),
    );
  }

  function productOfferLine(campaign, tier, mount) {
    var threshold = tierThreshold(tier);
    if (campaignBenefitType(campaign) === "FREE_GIFT") {
      return campaignThresholdType(campaign) === "QUANTITY"
        ? renderPromoText(mount, "BenefitFreeBuy", {
            gift: giftTitle(tier, mount),
            count: promotionQuantityText(campaign, threshold, mount),
          }) || campaignRuleTitle(campaign, tier, mount)
        : renderPromoText(mount, "BenefitFreeSpend", {
            gift: giftTitle(tier, mount),
            amount: formatMoney(centsFromAmount(threshold), mount),
          }) || campaignRuleTitle(campaign, tier, mount);
    }

    if (campaignThresholdType(campaign) !== "QUANTITY") {
      return campaignRuleTitle(campaign, tier, mount);
    }

    var eachCents = estimatedEachPriceCents(campaign, tier, mount);
    if (!eachCents) return campaignRuleTitle(campaign, tier, mount);
    return (
      renderPromoText(mount, "BenefitEach", {
        each: formatMoney(eachCents, mount),
        count: promotionQuantityText(campaign, threshold, mount),
      }) || campaignRuleTitle(campaign, tier, mount)
    );
  }

  function productSavingsLine(campaign, tier, mount) {
    var benefitType = campaignBenefitType(campaign);
    if (benefitType === "FREE_GIFT") {
      return promoTemplate(mount, "BenefitGiftUnlocks");
    }
    var threshold = tierThreshold(tier);
    var savingsCents = estimatedSavingsCents(campaign, tier, mount);
    if (savingsCents > 0) {
      return campaignThresholdType(campaign) === "QUANTITY"
        ? renderPromoText(mount, "BenefitYouSave", {
            savings: formatMoney(savingsCents, mount),
            count: promotionQuantityText(campaign, threshold, mount),
          })
        : formatMoney(savingsCents, mount);
    }
    return "";
  }

  function promotionAmountHtml(value) {
    return (
      '<span class="ss-product-promotion-card__amount">' +
      escapeHtml(value) +
      "</span>"
    );
  }

  function promotionQuantityHtml(campaign, quantity, mount) {
    return (
      promotionAmountHtml(trimDisplayNumber(quantity)) +
      " " +
      escapeHtml(promotionItemLabel(campaign, quantity, mount))
    );
  }

  function promotionQuantityText(campaign, quantity, mount) {
    return (
      trimDisplayNumber(quantity) +
      " " +
      promotionItemLabel(campaign, quantity, mount)
    );
  }

  function promotionItemLabel(campaign, quantity, mount) {
    var displayConfig =
      campaign && typeof campaign.displayConfig === "object"
        ? campaign.displayConfig
        : {};
    var itemLabel =
      (campaignBenefitType(campaign) === "BUY_N_PAY_M" ||
        campaignBenefitType(campaign) === "BUY_X_GET_Y") &&
      displayConfig &&
      typeof displayConfig.itemLabel === "object"
        ? displayConfig.itemLabel
        : {};
    var singular = cleanDisplayLabel(itemLabel && itemLabel.singular);
    var plural = cleanDisplayLabel(itemLabel && itemLabel.plural);
    if (Number(quantity || 0) === 1) {
      return singular || mount.dataset.promoItemOne || "item";
    }
    return (
      plural ||
      (singular ? inferPluralItemLabel(singular) : "") ||
      mount.dataset.promoItemOther ||
      "items"
    );
  }

  function inferPluralItemLabel(singular) {
    var value = cleanDisplayLabel(singular) || "item";
    if (value.toLowerCase() === "item") return "items";
    if (/[^aeiou]y$/i.test(value)) return value.slice(0, -1) + "ies";
    if (/(s|x|z|ch|sh)$/i.test(value)) return value + "es";
    return value + "s";
  }

  function cleanDisplayLabel(value) {
    return String(value == null ? "" : value)
      .replace(/<[^>]*>/g, " ")
      .replace(/\s+/g, " ")
      .trim()
      .slice(0, 80);
  }

  function promotionDynamicValueHtml(value) {
    var text = String(value == null ? "" : value);
    var pattern =
      /(?:[A-Z]{3}\s*)?(?:[$€£¥]\s*)?\d[\d,]*(?:\.\d+)?|\d[\d,]*(?:\.\d+)?\s*(?:%|[$€£¥]|[A-Z]{3})|\d[\d,]*(?:\.\d+)?/g;
    var html = "";
    var lastIndex = 0;
    var match;
    while ((match = pattern.exec(text))) {
      html += escapeHtml(text.slice(lastIndex, match.index));
      html += promotionAmountHtml(match[0]);
      lastIndex = match.index + match[0].length;
    }
    html += escapeHtml(text.slice(lastIndex));
    return html;
  }

  function promoTemplate(mount, key) {
    var datasetKey = "promo" + key;
    return String(
      (mount && mount.dataset && mount.dataset[datasetKey]) || "",
    ).trim();
  }

  function renderPromoText(mount, key, replacements) {
    var template = promoTemplate(mount, key);
    if (!template) return "";
    return replacePromoTokens(template, replacements);
  }

  function renderPromoHtml(mount, key, replacements) {
    var template = promoTemplate(mount, key);
    if (!template) return "";
    var html = "";
    var lastIndex = 0;
    var pattern = /\[([a-zA-Z0-9_]+)\]/g;
    var match;
    while ((match = pattern.exec(template))) {
      html += escapeHtml(template.slice(lastIndex, match.index));
      html +=
        replacements && replacements[match[1]] !== undefined
          ? replacements[match[1]]
          : "";
      lastIndex = match.index + match[0].length;
    }
    html += escapeHtml(template.slice(lastIndex));
    return html;
  }

  function replacePromoTokens(template, replacements) {
    return String(template || "").replace(
      /\[([a-zA-Z0-9_]+)\]/g,
      function (token, key) {
        if (!replacements || replacements[key] === undefined) return token;
        return String(replacements[key]);
      },
    );
  }

  function estimatedEachPriceCents(campaign, tier, mount) {
    var unitPriceCents = currentVariantPriceCents(mount);
    var quantity = tierThreshold(tier);
    if (!unitPriceCents || !quantity) return 0;
    var benefitType = campaignBenefitType(campaign);
    if (benefitType === "BUY_N_PAY_M" && Number(tier.payQuantity || 0) > 0) {
      return Math.max(
        0,
        Math.round((unitPriceCents * Number(tier.payQuantity || 0)) / quantity),
      );
    }
    if (benefitType === "FIXED_BUNDLE_PRICE") {
      return Math.max(
        0,
        Math.round(centsFromAmount(tier.fixedBundlePrice || 0) / quantity),
      );
    }
    if (benefitType === "PERCENTAGE_OFF") {
      return Math.max(
        0,
        Math.round(unitPriceCents * (1 - Number(tier.percentage || 0) / 100)),
      );
    }
    if (benefitType === "FIXED_AMOUNT_OFF") {
      return Math.max(
        0,
        Math.round(
          unitPriceCents - centsFromAmount(tier.discountAmount || 0) / quantity,
        ),
      );
    }
    return 0;
  }

  function estimatedSavingsCents(campaign, tier, mount) {
    var unitPriceCents = currentVariantPriceCents(mount);
    var quantity = tierThreshold(tier);
    var benefitType = campaignBenefitType(campaign);
    if (campaignThresholdType(campaign) !== "QUANTITY") {
      if (benefitType === "FIXED_AMOUNT_OFF") {
        return centsFromAmount(tier.discountAmount || 0);
      }
      return 0;
    }
    if (!unitPriceCents || !quantity) return 0;
    if (benefitType === "BUY_N_PAY_M") {
      return Math.max(
        0,
        Math.round(unitPriceCents * (quantity - Number(tier.payQuantity || 0))),
      );
    }
    if (benefitType === "BUY_X_GET_Y") {
      return Math.max(
        0,
        Math.round(
          (unitPriceCents *
            Number(tier.discountedQuantity || 0) *
            promotionPercentageOff(tier)) /
            100,
        ),
      );
    }
    if (benefitType === "FIXED_BUNDLE_PRICE") {
      return Math.max(
        0,
        Math.round(
          unitPriceCents * quantity -
            centsFromAmount(tier.fixedBundlePrice || 0),
        ),
      );
    }
    if (benefitType === "PERCENTAGE_OFF") {
      return Math.max(
        0,
        Math.round(
          (unitPriceCents * quantity * Number(tier.percentage || 0)) / 100,
        ),
      );
    }
    if (benefitType === "FIXED_AMOUNT_OFF") {
      return centsFromAmount(tier.discountAmount || 0);
    }
    return 0;
  }

  function countdownHtml(campaign, serverNow, mount) {
    var endMs = dateMs(campaign && campaign.endsAt);
    var nowMs = dateMs(serverNow) || Date.now();
    var diff = endMs - nowMs;
    if (!endMs || diff <= 0 || diff > WEEK_MS) return "";
    var format = diff > 24 * 60 * 60 * 1000 ? "dd:hh:mm:ss" : "hh:mm:ss";
    return (
      '<countdown-timer class="ss-product-promotion-countdown hidden" data-hide-on-expiry="true" data-format="' +
      format +
      '" data-endtime="' +
      escapeHtml(campaign.endsAt) +
      '" data-compact-labels="true" data-days="' +
      escapeHtml(
        countdownUnitLabel(mount.dataset.labelDay || mount.dataset.labelDays),
      ) +
      '" data-hours="' +
      escapeHtml(
        countdownUnitLabel(mount.dataset.labelHour || mount.dataset.labelHours),
      ) +
      '" data-mins="' +
      escapeHtml(
        countdownUnitLabel(mount.dataset.labelMin || mount.dataset.labelMins),
      ) +
      '" data-secs="' +
      escapeHtml(
        countdownUnitLabel(mount.dataset.labelSec || mount.dataset.labelSecs),
      ) +
      '"></countdown-timer>'
    );
  }

  function bindVariantUpdates(mount) {
    if (mount.__ssProductPromotionVariantBound) return;
    mount.__ssProductPromotionVariantBound = true;
    var productRoot = mount.closest(".product__item-js") || document;
    productRoot.addEventListener("change", function () {
      window.setTimeout(function () {
        updateVariantPrice(mount);
      }, 0);
    });
  }

  function updateVariantPrice(mount) {
    var variant = currentVariant(mount);
    if (!variant || !variant.price) return;
    var nextPrice = String(variant.price);
    var nextCompareAtPrice = String(variant.compare_at_price || 0);
    if (
      mount.dataset.productPriceCents === nextPrice &&
      mount.dataset.productCompareAtPriceCents === nextCompareAtPrice
    ) {
      return;
    }
    mount.dataset.productPriceCents = nextPrice;
    mount.dataset.productCompareAtPriceCents = nextCompareAtPrice;
    renderMount(mount);
  }

  function currentVariant(mount) {
    var productRoot = mount.closest(".product__item-js") || document;
    var selectedInput =
      productRoot.querySelector('form [name="id"]') ||
      productRoot.querySelector('[name="id"]');
    var selectedId = selectedInput && String(selectedInput.value || "");
    if (!selectedId) return null;
    return (mount.__ssProductPromotionVariants || []).find(function (variant) {
      return String(variant.id) === selectedId;
    });
  }

  function readVariants(mount) {
    var script = mount.querySelector("[data-ss-product-promotion-variants]");
    if (!script) return [];
    try {
      var variants = JSON.parse(script.textContent || "[]");
      return Array.isArray(variants) ? variants : [];
    } catch (error) {
      return [];
    }
  }

  function currentVariantPriceCents(mount) {
    var value = Number(mount.dataset.productPriceCents || 0);
    return Number.isFinite(value) ? value : 0;
  }

  function currentVariantCompareAtPriceCents(mount) {
    var value = Number(mount.dataset.productCompareAtPriceCents || 0);
    return Number.isFinite(value) ? value : 0;
  }

  function campaignBenefitType(campaign) {
    return String(
      (campaign && (campaign.benefitType || campaign.type)) || "",
    ).toUpperCase();
  }

  function isRepeatablePackCampaign(campaign) {
    var benefitType = campaignBenefitType(campaign);
    return benefitType === "BUY_N_PAY_M" || benefitType === "BUY_X_GET_Y";
  }

  function campaignThresholdType(campaign) {
    return campaign && campaign.thresholdType === "QUANTITY"
      ? "QUANTITY"
      : "SUBTOTAL";
  }

  function sortTiers(campaign) {
    return (campaign && Array.isArray(campaign.tiers) ? campaign.tiers : [])
      .slice()
      .sort(function (left, right) {
        return tierThreshold(left) - tierThreshold(right);
      });
  }

  function tierThreshold(tier) {
    return Number((tier && tier.thresholdValue) || 0);
  }

  function promotionPercentageOff(tier) {
    var percentage = Number(tier && tier.percentage);
    if (percentage >= 1 && percentage <= 100) return percentage;

    // Read legacy bootstrap payloads during a staggered app/theme rollout.
    var customerPaysPercentage = Number(
      tier && tier.customerPaysPercentage
    );
    return customerPaysPercentage > 0 && customerPaysPercentage < 100
      ? 100 - customerPaysPercentage
      : 0;
  }

  function giftTitle(tier, mount) {
    var fallbackGift = promoTemplate(mount, "Gift");
    var title =
      String(
        (tier && (tier.giftTitle || tier.giftProductHandle)) ||
          mount.dataset.productTitle ||
          fallbackGift,
      ).trim() || fallbackGift;
    return stripConfiguredFreeAffix(title, mount);
  }

  function stripConfiguredFreeAffix(value, mount) {
    var title = String(value || "").trim();
    var freeTokens = [mount.dataset.promoFree, "Free"]
      .map(function (item) {
        return String(item || "").trim();
      })
      .filter(Boolean);
    for (var index = 0; index < freeTokens.length; index += 1) {
      var token = escapeRegExp(freeTokens[index]);
      var leading = new RegExp("^" + token + "\\s+", "i");
      var trailing = new RegExp("\\s+" + token + "$", "i");
      if (leading.test(title)) return title.replace(leading, "").trim();
      if (trailing.test(title)) return title.replace(trailing, "").trim();
    }
    return title;
  }

  function escapeRegExp(value) {
    return String(value).replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
  }

  function productPromotionConfig(campaign) {
    var displayConfig = campaign && campaign.displayConfig;
    var config = displayConfig && displayConfig.productPromotion;
    if (!config) return null;
    if (config.enabled !== true && config.enabled !== "true") return null;
    return config;
  }

  function readCardStyle(config) {
    var style = String((config && config.style) || "").toLowerCase();
    return CARD_STYLES.includes(style) ? style : "hero";
  }

  function readColorVariant(config) {
    var colorVariant = String(
      (config && config.colorVariant) || "",
    ).toLowerCase();
    return COLOR_VARIANTS.includes(colorVariant) ? colorVariant : "theme";
  }

  function applyPresentationClasses(mount, style, colorVariant) {
    CARD_STYLES.forEach(function (classStyle) {
      mount.classList.remove("ss-product-promotion-mount--" + classStyle);
    });
    COLOR_VARIANTS.forEach(function (classColorVariant) {
      mount.classList.remove(
        "ss-product-promotion-mount--" + classColorVariant,
      );
    });
    mount.classList.add("ss-product-promotion-mount--" + style);
    mount.classList.add("ss-product-promotion-mount--" + colorVariant);
    mount.classList.toggle("mb-15", style === "compact");
    mount.classList.toggle("mb-20", style !== "compact");
  }

  function centsFromAmount(amount) {
    return Math.max(0, Math.round(Number(amount || 0) * 100));
  }

  function formatMoney(cents, mount) {
    if (window.Shopify && typeof window.Shopify.formatMoney === "function") {
      return window.Shopify.formatMoney(cents, mount.dataset.moneyFormat);
    }
    try {
      return new Intl.NumberFormat(document.documentElement.lang || "en", {
        style: "currency",
        currency: mount.dataset.currencyCode || "USD",
      }).format(Number(cents || 0) / 100);
    } catch (error) {
      return "$" + (Number(cents || 0) / 100).toFixed(2);
    }
  }

  function compactThresholdMoney(cents, mount) {
    return formatMoney(cents, mount).replace(/([.,])00(?=\D|$)/, "");
  }

  function normalizeHandleList(value) {
    var source = Array.isArray(value)
      ? value
      : String(value == null ? "" : value).split(",");
    var seen = new Set();
    return source.reduce(function (items, item) {
      var handle = normalizeHandle(item);
      if (handle && !seen.has(handle)) {
        seen.add(handle);
        items.push(handle);
      }
      return items;
    }, []);
  }

  function normalizeHandle(value) {
    return String(value == null ? "" : value)
      .trim()
      .toLowerCase();
  }

  function hasIntersection(left, right) {
    if (!left.length || !right.length) return false;
    return left.some(function (item) {
      return right.includes(item);
    });
  }

  function trimDisplayNumber(value) {
    var number = Number(value || 0);
    return Number.isInteger(number) ? String(number) : String(number);
  }

  function dateMs(value) {
    if (!value) return 0;
    var time = new Date(value).getTime();
    return Number.isFinite(time) ? time : 0;
  }

  function countdownUnitLabel(value) {
    var text = String(value || "").trim();
    if (!text || text.length > 3) return "";
    return text.toUpperCase();
  }

  function escapeHtml(value) {
    return String(value == null ? "" : value)
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;")
      .replace(/'/g, "&#039;");
  }

  function escapeAttribute(value) {
    return escapeHtml(value).replace(/`/g, "&#096;");
  }

  function tagIconHtml() {
    return (
      '<span class="ss-product-promotion-card__icon" aria-hidden="true">' +
      '<svg viewBox="0 0 24 24" focusable="false"><path d="M20.6 13.4 13.4 20.6a2 2 0 0 1-2.8 0L3 13V3h10l7.6 7.6a2 2 0 0 1 0 2.8Z" fill="currentColor"/><circle cx="8" cy="8" r="1.6" fill="var(--ss-product-promotion-icon-dot, #fff)"/></svg>' +
      "</span>"
    );
  }

  function hideMount(mount) {
    mount.hidden = true;
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () {
      init(document);
    });
  } else {
    init(document);
  }

  document.addEventListener("shopify:section:load", function (event) {
    init(event.target);
  });
})();
